import React from "react";
import styles from "./NoteChip.module.css";
import { InfoOutlined } from "@material-ui/icons";

export const NoteChip = ({ text }) => {
  return (
    <div className={styles.chip}>
      <InfoOutlined className={styles.chipIcon} />
      <div className={styles.chipText}>{text}</div>
    </div>
  );
};
